
/**
 * 상세 에러 정보
 * @nullable
 */
export type ErrorResponse2ErrorDetails = { [key: string]: unknown } | null;
